if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

(function () {
  var hash = window.location.hash;

  if (!hash) {
    window.addEventListener("beforeunload", function () {
      window.scrollTo(0, 0);
    });
    window.addEventListener("load", function () {
      window.scrollTo(0, 0);
    });
    return;
  }

  var pathSearch = window.location.pathname + window.location.search;
  try {
    history.replaceState(null, "", pathSearch);
  } catch (e) {}

  function scrollToHash() {
    var target;
    try {
      target = document.querySelector(hash);
    } catch (e) {
      target = null;
    }
    if (!target) return;
    var rect = target.getBoundingClientRect();
    window.scrollTo(0, Math.round(rect.top + window.pageYOffset));
  }

  function restoreHash() {
    try {
      history.replaceState(null, "", pathSearch + hash);
    } catch (e) {}
  }

  function isOverlayHidden(el) {
    if (!el) return true;
    if (el.style.display === "none") return true;
    var cs = window.getComputedStyle(el);
    return cs.display === "none" || cs.visibility === "hidden" || cs.opacity === "0";
  }

  function whenLayoutReady(callback) {
    var overlay = document.querySelector(".MS__layer-loading");
    if (isOverlayHidden(overlay)) {
      callback();
      return;
    }
    var done = false;
    function fire() {
      if (done) return;
      done = true;
      observer.disconnect();
      callback();
    }
    var observer = new MutationObserver(function () {
      if (isOverlayHidden(overlay)) fire();
    });
    observer.observe(overlay, {
      attributes: true,
      attributeFilter: ["style", "class"],
    });
    setTimeout(fire, 5000);
  }

  window.addEventListener("load", function () {
    whenLayoutReady(function () {
      requestAnimationFrame(function () {
        scrollToHash();
        restoreHash();
      });
    });
  });
})();
